import type { UserRole } from '@/types/auth'
import {
  ALL_CAPABILITIES,
  CAPABILITY_GRANTS,
  type Capability,
} from './capabilityGrantsData'

export type { Capability } from './capabilityGrantsData'
export { ALL_CAPABILITIES, CAPABILITY_GRANTS }

export function rolesWithCapability(capability: Capability): readonly UserRole[] {
  return CAPABILITY_GRANTS[capability]
}

export function capabilitiesForRoles(roles: readonly UserRole[]): ReadonlySet<Capability> {
  const out = new Set<Capability>()
  if (roles.includes('SystemAdmin')) {
    for (const cap of ALL_CAPABILITIES) out.add(cap)
    return out
  }
  for (const cap of ALL_CAPABILITIES) {
    if (roles.some((r) => CAPABILITY_GRANTS[cap].includes(r))) out.add(cap)
  }
  return out
}

export function hasCapability(
  roles: readonly UserRole[] | undefined,
  capability: Capability
): boolean {
  if (!roles?.length) return false
  if (roles.includes('SystemAdmin')) return true
  return roles.some((r) => CAPABILITY_GRANTS[capability].includes(r))
}

export function hasCapabilityForRoles(
  roles: readonly UserRole[] | undefined,
  capability: Capability,
  options?: { narrowToRole?: UserRole | null }
): boolean {
  if (options?.narrowToRole) {
    return hasCapability([options.narrowToRole], capability)
  }
  return hasCapability(roles, capability)
}
